import { render, staticRenderFns } from "./TecnologiesNotVerified.vue?vue&type=template&id=f6e9f504&"
import script from "./TecnologiesNotVerified.vue?vue&type=script&lang=js&"
export * from "./TecnologiesNotVerified.vue?vue&type=script&lang=js&"
import style0 from "./TecnologiesNotVerified.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports